module.exports = __webpack_public_path__ + "assets/images/intro/covid-hits-home-scrollyimage2-desktop.jpg?v=9dd9aa58";